import script from "./OrganizationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationView.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationView.vue?vue&type=style&index=0&id=a655c2fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a655c2fc"]])

export default __exports__